import { useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Upload, FileCheck2 } from "lucide-react";
import { errText } from "./docFile";

export function PodSection({ dc, onSaved }) {
  const [by, setBy] = useState(dc.pod?.received_by || "");
  const [on, setOn] = useState(dc.pod?.received_at || "");
  const [busy, setBusy] = useState(false);
  const can = ["DISPATCHED", "DELIVERED"].includes(dc.status);
  const open = async () => {
    try { const r = await api.get(`/document-centre/dcs/${dc.id}/pod`, { responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); } catch (e) { toast.error(await errText(e)); }
  };
  const upload = async (file) => {
    if (!file) return;
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file); if (by) fd.append("received_by", by); if (on) fd.append("received_at", on);
    try { await api.post(`/document-centre/dcs/${dc.id}/pod`, fd); toast.success("Proof of Delivery attached"); onSaved(); } catch (e) { toast.error(await errText(e)); }
    setBusy(false);
  };
  return (
    <div className="rounded-lg border border-dashed border-slate-300 p-3" data-testid="pod-section">
      <div className="mb-2 flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] text-slate-600">Proof of Delivery
        {dc.pod && <button onClick={open} className="inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2 py-0.5 text-[10.5px] font-semibold normal-case tracking-normal text-emerald-800 hover:bg-emerald-100" data-testid="pod-open"><FileCheck2 className="h-3 w-3" />{dc.pod.filename}</button>}
      </div>
      {!can ? <p className="text-[11px] text-slate-500" data-testid="pod-locked">Available once the DC is dispatched.</p> : (
        <div className="flex flex-wrap items-end gap-2">
          <input value={by} onChange={(e) => setBy(e.target.value)} placeholder="Received by" className="w-40 rounded-md border border-slate-300 px-2 py-1 text-[12px]" data-testid="pod-received-by" />
          <input type="date" value={on} onChange={(e) => setOn(e.target.value)} className="rounded-md border border-slate-300 px-2 py-1 text-[12px]" data-testid="pod-received-at" />
          <label className={`inline-flex cursor-pointer items-center gap-1 rounded-full border border-slate-300 px-3 py-1 text-[11px] font-semibold hover:bg-slate-50 ${busy ? "opacity-50" : ""}`} data-testid="pod-upload-label">
            <Upload className="h-3.5 w-3.5" />{busy ? "Uploading…" : dc.pod ? "Replace POD" : "Upload POD"}
            <input type="file" accept="application/pdf,image/*" className="hidden" disabled={busy} onChange={(e) => upload(e.target.files?.[0])} data-testid="pod-file-input" />
          </label>
        </div>)}
    </div>
  );
}
